import { Navigate, Outlet, useLocation } from 'react-router'
import { AuthLoadingState } from './AuthLoadingState'
import { useWorkspace } from '../contexts/WorkspaceContext'
import { useAuth } from '../contexts/AuthContext'
import { Button } from './ui/button'

function roleFromAuth(roles?: string[]): string | null {
  return roles?.map((role) => role.toUpperCase()).find((role) => (
    role === 'ADMIN' || role === 'TEACHER' || role === 'STUDENT'
  )) ?? null
}

export function WorkspaceGate() {
  const location = useLocation()
  const { user, logout } = useAuth()
  const { isLoading, isResolved, error, memberRole, workspaceEntered } = useWorkspace()

  if (isLoading) {
    return <AuthLoadingState label="Loading workspace..." />
  }

  const resolvedRole = memberRole ?? roleFromAuth(user?.roles)

  if (error && !isResolved) {
    const canCreateWorkspace = resolvedRole === 'ADMIN'
    if (canCreateWorkspace && location.pathname !== '/admin/workspaces') {
      return <Navigate to="/admin/workspaces" replace />
    }
    if (canCreateWorkspace && location.pathname === '/admin/workspaces') {
      return <Outlet />
    }

    return (
      <div className="flex min-h-screen items-center justify-center bg-background p-6 text-foreground">
        <div className="w-full max-w-md rounded-base border-2 border-nb-border bg-secondary-bg p-6 shadow-shadow">
          <h1 className="font-heading text-xl">Workspace unavailable</h1>
          <p className="mt-3 text-sm text-foreground/70">{error}</p>
          <div className="mt-6 flex gap-3">
            <Button onClick={() => window.location.reload()}>Retry</Button>
            <Button variant="neutral" onClick={() => void logout()}>Sign out</Button>
          </div>
        </div>
      </div>
    )
  }

  if (!isResolved) {
    return <AuthLoadingState label="Loading workspace..." />
  }

  if (resolvedRole === 'ADMIN' && !workspaceEntered && location.pathname !== '/admin/workspaces') {
    return <Navigate to="/admin/workspaces" replace />
  }

  return <Outlet />
}
